import { toAbsoluteUrl } from "./toAbsoluteUrl";
import { truncate } from "./truncate";
import { buildKeywords } from "./keywords";

const SITE_NAME = "Clear Choice Cleaning Services";

export function buildMeta({ title, description, path, image, keywords }) {
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  const desc = truncate(description);
  const url = toAbsoluteUrl(path);
  const absoluteImage = toAbsoluteUrl(image);

  return {
    title: fullTitle,
    description: desc,
    keywords: buildKeywords(keywords),
    canonical: url,
    og: {
      title: fullTitle,
      description: desc,
      url,
      image: absoluteImage,
      type: "website",
    },
    twitter: {
      card: "summary_large_image",
      title: fullTitle,
      description: desc,
      image: absoluteImage,
    },
  };
}
